// extracted by mini-css-extract-plugin
export var circle = "_8x-1";
export var exitConfirmationModal = "_8x-5";
export var iframe = "_8x-0";
export var offline = "_8x-3";
export var online = "_8x-2";
export var workstationSelectError = "_8x-4";